import React from "react";
import AboutUsDetailCard from "./Components/AboutUsDetailCard.js";

const AboutUsVisionSection = () => {
  return (
    <section className="p-4 md:p-20 my-[6%]">
      <AboutUsDetailCard
        left={false}
        title="Our vision"
        imageUrl="/images/about-us-page/about-us-image-3.png"
        description="We help organizations unlock AI’s true potential with solutions that are both strategic and practical. By blending vision with technical expertise, we guide clients through complexity, reveal hidden opportunities, and drive meaningful progress turning possibilities into tangible impact."
      />
    </section>
  );
};

export default AboutUsVisionSection;
